import { BaseCommand } from "@crunchdao/shared-cli";
import { StakingClient, formatCrunch, parseCrunch } from "@crunchdao/sdk";
import { PublicKey } from "@solana/web3.js";

export class UndelegateCommand extends BaseCommand {
  async execute(coordinator: PublicKey, amount: number): Promise<void> {
    try {
      const formattedAmount = formatCrunch(parseCrunch(amount));
      this.displayAction(`Undelegating ${formattedAmount} CRNCH from ${coordinator.toBase58()}`);

      const stakingClient = new StakingClient({
        connection: this.provider.connection,
        wallet: this.provider.wallet,
      });

      const amountBigInt = parseCrunch(amount);

      const signature = await stakingClient.unstakeFromCoordinator(coordinator, amountBigInt);

      if (!signature) {
        console.log("❌ No eligible positions found for undelegation");
        return;
      }

      this.displayActionComplete(`Undelegated ${formattedAmount} CRNCH`);
      console.log(`Transaction: ${signature}`);
    } catch (error) {
      console.error("❌ Error undelegating tokens:", error);
      throw error;
    }
  }
}
